import { BoolType, ConferenceInterface, RoleCode } from "@/types";
import { ParticipantType } from "@/types";

const getPeerUserId = (conf: ConferenceInterface, peerId?: string) => {
  if (!peerId) return "";
  const roomPrefix = `${conf.roomId}_`;
  return peerId.startsWith(roomPrefix) ? peerId.slice(roomPrefix.length) : peerId.split("_").pop();
};

const isHostUser = (conf: ConferenceInterface, userId?: string) => {
  if (!userId) return false;
  return String(userId) === String(conf.ownerId) || String(userId) === String(conf.currHostUserId);
};

// 初始化时，rolecode 与 是否举手，不加ps 是自己进入的时候直接查
export const getSelf = (
  conf: ConferenceInterface,
  ps?: Array<ParticipantType>
) => {
  const selfPeerId = `${conf.roomId}_${conf.userId}`;
  let selfPeer = (ps || []).find(
    (x) => x.peerId === selfPeerId
  );
  if (selfPeer) {
    return isHostUser(conf, conf.userId) ? { ...selfPeer, roleCode: RoleCode.host } : selfPeer;
  }

  selfPeer = (conf.attendList || []).find(
    (x) => x.peerId === selfPeerId
  );
  if (selfPeer) {
    return isHostUser(conf, conf.userId) ? { ...selfPeer, roleCode: RoleCode.host } : selfPeer;
  }

  return {
    peerId: selfPeerId,
    roleCode: isHostUser(conf, conf.userId) ? RoleCode.host : (conf.roleCode) || RoleCode.guest,
    raiseHandStatus: (selfPeer && selfPeer.raiseHandStatus) || BoolType.no,
  } as ParticipantType;
};

export const getPeer = (
  conf: ConferenceInterface,
  p: ParticipantType,
  ps: Array<ParticipantType> = []
) => {
  let peer = ps.find((x) => x.peerId === p.peerId);
  if (peer) return peer;

  peer = (conf.attendList || []).find((x) => x.peerId === p.peerId);
  const isHostExists = ps.some((x) => x.roleCode === RoleCode.host) || (conf.attendList || []).some((x) => x.roleCode === RoleCode.host);
  const fallbackRoleCode = isHostUser(conf, getPeerUserId(conf, p.peerId)) ? RoleCode.host : RoleCode.guest;

  return {
    roleCode: (peer && peer.roleCode) || fallbackRoleCode,
    raiseHandStatus: (peer && peer.raiseHandStatus) || BoolType.no,
  } as ParticipantType;
  // return {
  //   roleCode: !isHostExists && peer && peer.roleCode || RoleCode.guest,
  //   raiseHandStatus: (peer && peer.raiseHandStatus) || BoolType.no,
  // } as ParticipantType;
};

export const selfIsManage = (
  conf: ConferenceInterface,
  ps?: Array<ParticipantType>
) => {
  const peer: ParticipantType = getSelf(conf, ps);
  // 以当前参会者角色为准，主持人/联席主持人都具备会控权限。
  return isHostUser(conf, conf.userId) || peer.roleCode === RoleCode.host || peer.roleCode === RoleCode.cohost;
};

// 是否有人举手
export const haveHandup = (ps: Array<ParticipantType> = []) => {
  const item = ps.find((x: ParticipantType) => x.raiseHandStatus);
  return !!item;
};

// peer是否自己
export const isSelf = (conf: ConferenceInterface, p: ParticipantType) => {
  return p.peerId === `${conf.roomId}_${conf.userId}`;
};

export const moreLevel = (
  conf: ConferenceInterface,
  peer: ParticipantType,
  ps?: Array<ParticipantType>
) => {
  const selfPeer = getSelf(conf, ps);
  const ppeer = getPeer(conf, peer, ps);
  return (
    (selfPeer.roleCode === RoleCode.cohost &&
      ppeer.roleCode === RoleCode.guest) ||
    (selfPeer.roleCode === RoleCode.host && ppeer.roleCode !== RoleCode.host)
  );
};

///////////////////////////////////////////////////////////////
// peer
// can mute ...
export const canMute = (
  conf: ConferenceInterface,
  peer: ParticipantType,
  ps?: Array<ParticipantType>
) => {
  const peerisself = isSelf(conf, peer);
  if (!peerisself) {
    return moreLevel(conf, peer, ps);
  } else {
    if (selfIsManage(conf, ps)) {
      return true;
    } else {
      return !conf.allowSelfUnmute;
    }
  }
};

// 是否可控制视频开关
export const canVideo = (
  conf: ConferenceInterface,
  peer: ParticipantType,
  ps?: Array<ParticipantType>
) => {
  return isSelf(conf, peer) || moreLevel(conf, peer, ps);
};

// 显示举手
export const canHandup = (
  conf: ConferenceInterface,
  peer: ParticipantType,
  ps?: Array<ParticipantType>
) => {
  return !selfIsManage(conf, ps) && isSelf(conf, peer);
};

// 显示改名
export const canRename = (
  conf: ConferenceInterface,
  peer: ParticipantType,
  ps?: Array<ParticipantType>
) => {
  const peerisself = isSelf(conf, peer);
  if (peerisself) return true;
  return moreLevel(conf, peer, ps);
};

// 是否显示。。成为主持人
export const canHost = (
  conf: ConferenceInterface,
  peer: ParticipantType,
  ps?: Array<ParticipantType>
) => {
  const sself = getSelf(conf, ps);
  const isssself = isSelf(conf, peer);
  const apeer = getPeer(conf, peer, ps);
  return (
    !isssself &&
    sself.roleCode === RoleCode.host &&
    apeer.roleCode !== RoleCode.host
  );
};

// 是否显示。。成为联合主持人
export const canCohost = (
  conf: ConferenceInterface,
  peer: ParticipantType,
  ps: Array<ParticipantType> = []
) => {
  const sself = getSelf(conf, ps);
  const isssself = isSelf(conf, peer);
  const apeer = getPeer(conf, peer, ps);
  return (
    !isssself &&
    sself.roleCode === RoleCode.host &&
    apeer.roleCode === RoleCode.guest
  );
};

export const showRemove = (
  conf: ConferenceInterface,
  peer: ParticipantType,
  ps: Array<ParticipantType> = []
) => {
  return moreLevel(conf, peer, ps);
};
